import { MDXProvider } from "@mdx-js/react";
import React, { FC } from "react";

import { Typography } from "@mui/material";

export const MdxProvider: FC = ({ children }) => {
  const components = {
    h1: (props: any) => <Typography variant="h4" {...props} gutterBottom />,
    h2: (props: any) => <Typography variant="h5" {...props} gutterBottom />,
    p: (props: any) => <Typography variant="body1" {...props} gutterBottom />,
  };
  return <MDXProvider components={components}>{children}</MDXProvider>;
};
